import React, { useState, FormEvent, ChangeEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import addToMailchimp from 'gatsby-plugin-mailchimp';

import './style.css';

interface Props {
  onSubscribe: (success: boolean) => void;
}

const Form = (props: Props) => {
  const [email, setEmail] = useState('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    setEmail(target.value);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const { onSubscribe } = props;
      await addToMailchimp(email, {});
      onSubscribe(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form autoComplete="off" noValidate onSubmit={handleSubmit}>
      <div id="mc_embed_signup_scroll">
        <div className="md:flex items-center">
          <TextField
            type="email"
            value={email}
            onChange={handleChange}
            label="Correo electrónico*"
            className="bg-transparent w-full mb-4 md:mb-0 border-b border-white"
            name="EMAIL"
          />
          <button
            type="submit"
            disabled={!email}
            className="text-green-200 py-3 md:ml-4 mt-4 block px-10 bg-white tracking-wider font-thin rounded-lg block m-0 border-0"
          >
            Suscribirme
          </button>
        </div>
        <div id="mce-responses">
          <div className="response hidden" id="mce-error-response" />
          <div className="response hidden" id="mce-success-response" />
        </div>
        <div style={{ position: 'absolute', left: '-5000px' }}>
          <input
            type="text"
            name="b_5f643166bf95924ebb5c9cc03_0846435ad7"
            tabIndex={-1}
            onChange={() => {}}
          />
        </div>
      </div>
    </form>
  );
};

export default Form;
